<template>
  <SocialLanding />
</template>

<script>
import SocialLanding from '@/views/SocialLanding.vue';

export default {
  name: 'AppQrLanding',
  components: { SocialLanding },
};
</script>
